import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import {
  Box,
  SubHeadingStyled,
  DataContainerHeader,
  ThemeLoader,
} from "../../../components/styled/Elements";
import { SettingsWrapper, FormDataContainer } from "./styled";
import { useNavigate, useParams } from "react-router-dom";
import { viewDetailArray } from "../../../helpers/adminConstants/AdminConstants";
import {
  PlaceholderImg,
  SearchIcon,
} from "../../../components/styled/AllImages";
import ListTable from "../../../components/common/tables/ListTable";
import { adminsViewsListColumns } from "../../../helpers/adminConstants/TableConstants";
import { InformationRowWrapper } from "../../../components/styled/styled";
import FloatingInput from "../../../components/common/inputFields/FloatingInput";
import ViewDetailBar from "../../../components/common/viewDetailBar/viewDetail";
import AdminsListApi from "../../../services/api/adminListApi";
import { getFormattedDate } from "../../../utils";
import { useDebounce } from "../../../hooks/useDebounce";

const AdminDetails = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const navigate = useNavigate();
  const [viewDetail, setviewDetail] = useState(viewDetailArray);
  const { id } = useParams(); // Extract the ID from the URL
  const [adminsViewsListRows, setAdminsViewsListRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [activePage, setActivePage] = useState(1);
  const [totalCount, setTotalCount] = useState(null);
  const [perPage, setPerPage] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const debouncedSearchQuery = useDebounce(searchQuery, 500);
  const ASSET_URL = process.env.REACT_APP_ASSET_URL;

  const handleSearch = (e) => {
    const query = e.target.value.trim();
    setSearchQuery(query);
  };

  const getData = async (id, activePage, query) => {
    try {
      setLoading(true);
      const response = await AdminsListApi.adminView(id, activePage, query);
      if (response?.data) {
        const updatedViewDetail = viewDetailArray.map((item) => {
          switch (item.title) {
            case "AdminName":
              return { ...item, value: response?.data?.adminUser?.name || "" };
            case "email":
              return { ...item, value: response?.data?.adminUser?.email || "" };
            case "ContactNo":
              return { ...item, value: response?.data?.adminUser?.phone || "" };
            case "numOfLicensePlaceholder":
              return {
                ...item,
                value: response?.data?.adminUser?.user_detail?.licenses_allowed,
              };
            case "NoofUsersCreated":
              return {
                ...item,
                value: response?.data?.adminUser?.user_detail?.licenses_created,
              };
            case "no_of_licenses_left":
              return {
                ...item,
                value: response?.data?.adminUser?.user_detail?.licenses_left,
              };

            default:
              return item;
          }
        });
        setviewDetail(updatedViewDetail);

        const adminsDetailListResponse =
          response?.data?.createdUsers?.data || []; // Fallback to an empty array
        const updateAdminsViewsListRows = adminsDetailListResponse.map(
          (list) => ({
            id: list?.id,
            status: list?.status,
            user: {
              name: list?.name,
              image: list?.profile
                ? `${ASSET_URL}/${list?.profile}`
                : PlaceholderImg,
            },
            department: {
              userName: list?.name,
              userRole: list?.user_detail?.position
                ? list?.user_detail?.position
                : list?.user_detail?.position
                ? list?.user_detail?.position
                : `${
                    language === "en"
                      ? list?.user_detail?.department_selective?.name_en
                      : list?.user_detail?.department_selective?.name_ar
                  } (${
                    language === "en"
                      ? list?.user_detail?.office_location_selective?.name_en
                      : list?.user_detail?.office_location_selective?.name_ar
                  })`,
              userImage: list?.profile
                ? `${ASSET_URL}/${list?.profile}`
                : PlaceholderImg,
              department_info: [
                {
                  title: "DateofCreation",
                  value: getFormattedDate(list?.created_at),
                },
                {
                  title: "JobRoll",
                  value: list?.position,
                },
                {
                  title: "department",
                  value: list?.user_detail?.department_selective?.name_en,
                },
                { title: "ContactEmail", value: list?.email },
                { title: "ContactNumber", value: list?.phone },
              ],
            },
          })
        );
        setAdminsViewsListRows(updateAdminsViewsListRows);
        setTotalCount(response?.data?.createdUsers?.total);
        setPerPage(response?.data?.createdUsers?.per_page);
      } else {
        setAdminsViewsListRows([]);
        setTotalCount(null);
        setPerPage(null);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      getData(id, activePage, debouncedSearchQuery);
    }
  }, [id, language, activePage, debouncedSearchQuery]);

  return (
    <SettingsWrapper>
      <Box className="content-head">
        <SubHeadingStyled size="16px" color="var(--text)">
          {t("settings")}
        </SubHeadingStyled>
        <Box>
          <FloatingInput
            name="search"
            type="input"
            fieldType="text"
            placeholder={t("search_by_name")}
            icon={SearchIcon}
            onChange={handleSearch}
          />
        </Box>
      </Box>
      {loading ? (
        <ThemeLoader />
      ) : (
        <>
          <Box className="content-container">
            <Row className="mt-3">
              <Col md={12}>
                <FormDataContainer className="dataContainer">
                  <DataContainerHeader
                    label={t("admins_list")}
                    backBtnLabel="admins_list"
                    onClickBack={() => navigate("/settings/admins-list")}
                  />
                </FormDataContainer>
              </Col>
            </Row>
          </Box>
          <Box>
            <InformationRowWrapper className="m-3">
              <Box className="table-content">
                {viewDetail.map((details, key) => (
                  <ViewDetailBar {...details} key={key} />
                ))}
              </Box>
            </InformationRowWrapper>
          </Box>
          <Box>
            <ListTable
              options={["tooltip2"]}
              rows={adminsViewsListRows}
              columns={adminsViewsListColumns}
              totalCount={totalCount}
              perPage={perPage}
              activePage={activePage}
              setActivePage={setActivePage}
            />
          </Box>
        </>
      )}
    </SettingsWrapper>
  );
};

export default AdminDetails;
